import { render } from "./SearchDropdown.vue?vue&type=template&id=736363b9&scoped=true"
import script from "./SearchDropdown.vue?vue&type=script&lang=js"
export * from "./SearchDropdown.vue?vue&type=script&lang=js"

import "./SearchDropdown.vue?vue&type=style&index=0&id=736363b9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-736363b9"

export default script